var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.31 265.54C90.31 265.54 101.98 328.43 161.17 362.54C220.36 396.65 293.92 388.54 353.71 383.47C413.5 378.4 453.86 338 453 286.3C452.14 234.6 404.64 226.63 371.31 172.72C337.98 118.81 337.27 99.53 280 72C222.73 44.47 144.72 78.6 111.4 145.83C78.08 213.06 90.31 265.54 90.31 265.54Z",
    fill: "#25BDBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M90.31 265.54C90.31 265.54 101.98 328.43 161.17 362.54C220.36 396.65 293.92 388.54 353.71 383.47C413.5 378.4 453.86 338 453 286.3C452.14 234.6 404.64 226.63 371.31 172.72C337.98 118.81 337.27 99.53 280 72C222.73 44.47 144.72 78.6 111.4 145.83C78.08 213.06 90.31 265.54 90.31 265.54Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.5 447C317.203 447 386.68 441.977 386.68 435.78C386.68 429.583 317.203 424.56 231.5 424.56C145.796 424.56 76.3199 429.583 76.3199 435.78C76.3199 441.977 145.796 447 231.5 447Z",
    fill: "#25BDBE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M231.5 447C317.203 447 386.68 441.977 386.68 435.78C386.68 429.583 317.203 424.56 231.5 424.56C145.796 424.56 76.3199 429.583 76.3199 435.78C76.3199 441.977 145.796 447 231.5 447Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M428 76.5H194.32C188.797 76.5 184.32 80.9772 184.32 86.5V394.85C184.32 400.373 188.797 404.85 194.32 404.85H428C433.523 404.85 438 400.373 438 394.85V86.5C438 80.9772 433.523 76.5 428 76.5Z",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M290.83 166.73V167.75H289.81",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M287.79 167.75H228.3",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.02 2.02"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M227.29 167.75H226.26V166.73",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M226.26 164.76V118.49",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.97 1.97"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M226.26 117.5V116.48H227.29",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M229.3 116.48H288.8",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.02 2.02"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M289.81 116.48H290.83V117.5",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M290.83 119.47V165.75",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.97 1.97"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M280.52 124.67H236.57V159.57H280.52V124.67Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M233.99 122.08L218.91 110.45",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M283.54 161.29L296.47 172.49",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M218.31 114.28L217.87 109.33H223.04",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M296.82 167.81L297.71 173.21L291.42 173.44",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M334.95 299.36H313.61V307.06H334.95V299.36Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M343.62 303.2L329.94 295.31V311.1L343.62 303.2Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M298.22 246.25H249.14C245.313 246.25 242.21 249.353 242.21 253.18V362.16C242.21 365.987 245.313 369.09 249.14 369.09H298.22C302.047 369.09 305.15 365.987 305.15 362.16V253.18C305.15 249.353 302.047 246.25 298.22 246.25Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.829236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M302.36 254.59H245.01V361.79H302.36V254.59Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.829236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M291.73 386L296.11 369C296.589 367.168 296.831 365.283 296.83 363.39V343C296.909 342.737 296.953 342.465 296.96 342.19C296.901 341.282 296.485 340.433 295.803 339.83C295.121 339.227 294.229 338.918 293.32 338.97C292.338 338.951 291.386 339.309 290.66 339.97C290.528 339.12 290.086 338.348 289.42 337.804C288.754 337.259 287.91 336.98 287.05 337.02C286.456 337.008 285.868 337.138 285.334 337.399C284.8 337.66 284.336 338.044 283.98 338.52C283.835 337.682 283.39 336.925 282.727 336.391C282.064 335.857 281.23 335.583 280.38 335.62C279.784 335.611 279.194 335.743 278.659 336.006C278.124 336.268 277.658 336.653 277.3 337.13C277.3 334.43 277.3 321.48 276.85 320.42C275.53 317.01 268.85 318.57 270.04 322.19V352.14C270.04 350.04 268.48 347.27 267.83 345.23C267.18 343.19 266.83 341.23 265.59 339.53C263.53 336.59 259.9 338.21 260.11 341.27C260.28 343.96 262.23 346.08 263.28 348.52C265.22 353.02 264.06 357.73 265.89 362.25C267.41 365.115 269.099 367.887 270.95 370.55C271.948 372.298 272.736 374.158 273.3 376.09L271.6 386",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M291.73 386L296.11 369C296.589 367.168 296.831 365.283 296.83 363.39V343C296.909 342.737 296.953 342.465 296.96 342.19C296.901 341.282 296.485 340.433 295.803 339.83C295.121 339.227 294.229 338.918 293.32 338.97C292.338 338.951 291.386 339.309 290.66 339.97C290.528 339.12 290.086 338.348 289.42 337.804C288.754 337.259 287.91 336.98 287.05 337.02C286.456 337.008 285.868 337.138 285.334 337.399C284.8 337.66 284.336 338.044 283.98 338.52C283.835 337.682 283.39 336.925 282.727 336.391C282.064 335.857 281.23 335.583 280.38 335.62C279.784 335.611 279.194 335.743 278.659 336.006C278.124 336.268 277.658 336.653 277.3 337.13C277.3 334.43 277.3 321.48 276.85 320.42C275.53 317.01 268.85 318.57 270.04 322.19V352.14C270.04 350.04 268.48 347.27 267.83 345.23C267.18 343.19 266.83 341.23 265.59 339.53C263.53 336.59 259.9 338.21 260.11 341.27C260.28 343.96 262.23 346.08 263.28 348.52C265.22 353.02 264.06 357.73 265.89 362.25C267.41 365.115 269.099 367.887 270.95 370.55C271.948 372.298 272.736 374.158 273.3 376.09L271.6 386",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M273.73 310.1V315.7",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M280.03 320.94H284.58",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M261.14 320.94H265.69",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M267.44 315L269.19 317.79",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M277.93 318.14L280.38 315",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M300.32 296.11H247.15V302.76H300.32V296.11Z",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M274.44 260.43H248.9V290.86H274.44V260.43Z",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M248.9 260.43L274.43 290.86",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M248.2 349.63V306.25H299.97V349.28",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M404.07 246.25H354.99C351.163 246.25 348.06 249.353 348.06 253.18V362.16C348.06 365.987 351.163 369.09 354.99 369.09H404.07C407.897 369.09 411 365.987 411 362.16V253.18C411 249.353 407.897 246.25 404.07 246.25Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.829236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M408.21 254.59H350.86V361.79H408.21V254.59Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.829236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M405.61 259.73H353.84V316.4H405.61V259.73Z",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M353.84 321.64H405.61",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M353.84 325.84H405.61",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M353.84 330.04H405.61",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M353.84 334.24H405.61",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M353.84 338.43H405.61",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M353.84 342.63H405.61",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M353.84 346.83H405.61",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M353.84 316.4L405.61 259.73",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M404.07 105.24H354.99C351.163 105.24 348.06 108.343 348.06 112.17V221.15C348.06 224.977 351.163 228.08 354.99 228.08H404.07C407.897 228.08 411 224.977 411 221.15V112.17C411 108.343 407.897 105.24 404.07 105.24Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.829236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M408.21 113.58H350.86V220.78H408.21V113.58Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.829236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M284.65 242.59V209.92H330.62",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M329.12 215.02L337.95 209.92L329.12 204.82V215.02Z",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M378.37 241.73V216.65",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M383.47 218.15L378.37 209.31L373.27 218.15H383.47Z",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M354.67 380.27H377.86",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M354.67 385.49H377.86",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M354.67 390.7H377.86",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M298.44 380.27H321.63",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M298.44 385.49H321.63",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M298.44 390.7H321.63",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M292.06 220.27H315.25",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M292.06 225.48H315.25",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M292.06 230.7H315.25",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M309.45 157.08H332.64",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M309.45 162.3H332.64",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M309.45 167.51H332.64",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M225.97 175.05H249.16",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M225.97 180.27H249.16",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M225.97 185.48H249.16",
    stroke: "#263238",
    strokeWidth: 1.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M132 424C132 424 129.85 432.28 129.85 434.37C129.85 436.46 129.33 437.86 133.85 438.73C138.37 439.6 141.35 439.08 142.05 436.99C142.75 434.9 143.27 424.42 143.27 424.42L132.27 422.32L132 424Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M142 437C142.142 436.523 142.242 436.034 142.3 435.54C138.106 435.562 133.917 435.228 129.78 434.54C129.78 436.54 129.39 437.89 133.78 438.73C138.17 439.57 141.33 439.09 142 437Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M238.05 424.78C238.05 424.78 241.54 426 246.61 427.57C251.68 429.14 262 430.89 263 431.06C264 431.23 264 433.33 263.17 434.21C262.34 435.09 257.76 437.7 252.35 439.09C246.94 440.48 228.6 441.71 227.03 440.67C225.72 439.79 226.16 431.24 226.68 429.32C227.2 427.4 238.05 424.78 238.05 424.78Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M263.19 434.21C263.475 433.878 263.672 433.48 263.763 433.051C263.854 432.623 263.836 432.179 263.71 431.76C260.17 434.58 253.1 437.68 245.91 438.4C239.384 438.865 232.831 438.832 226.31 438.3C226.44 439.5 226.67 440.41 227.05 440.67C228.62 441.67 246.95 440.49 252.37 439.09C257.79 437.69 262.32 435.08 263.19 434.21Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M153.6 272.57C153.6 272.57 150.6 290.83 152.92 300.97C152.92 300.97 148.53 341.19 147.85 359.11C147.85 359.11 138.39 390.55 137.03 400.35C135.749 408.312 134.071 416.205 132 424C134.104 425.164 136.39 425.965 138.76 426.37C143.5 427.37 144.17 423.66 144.17 423.66C144.17 423.66 170.17 363.83 172.23 355.04C174.29 346.25 181 314.83 181 314.83L209 366.21C209 366.21 210.36 383.79 214.41 393.93C218.46 404.07 226.24 432.12 226.24 432.12C229.318 432.291 232.402 431.953 235.37 431.12C239.43 429.77 239.43 427.74 239.43 427.74C239.43 427.74 233.34 405.09 233.34 397.66C233.34 390.23 230.98 364.87 229.29 357.77C227.6 350.67 216.1 313.49 214.41 309.43C212.72 305.37 209 292.53 209 292.53L206.64 272.58C206.64 272.58 177.6 280.69 153.6 272.57Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M175.05 186.42C175.05 186.42 173.49 183.05 173.49 180.98C173.49 178.91 172.49 169.07 172.49 169.07C172.49 169.07 187.49 141.9 191.64 136.72C194.347 133.402 197.382 130.367 200.7 127.66C200.7 127.66 210.8 125.59 212.87 125.59C214.94 125.59 217.27 124.59 217.27 123.26C217.27 121.93 213.9 122.26 211.83 122.26C209.76 122.26 207.17 120.45 207.17 120.45C207.17 120.45 210.54 110.8 211.57 106.99C212.12 104.99 213.9 100.78 212.57 100.78C211.24 100.78 211.02 101.78 210.24 103.37C209.46 104.96 206.1 110.1 206.1 110.1L206.87 98.7099C206.87 98.7099 205.87 97.1599 205.06 98.9699C204.034 101.765 203.169 104.616 202.47 107.51C202.23 108.416 201.789 109.257 201.18 109.97L200.18 101.48C200.18 101.48 198.42 99.6099 198.11 102.85C197.94 104.65 198.11 110.62 198.11 111.65C198.11 112.68 197.11 110.18 197.11 110.18C197.11 110.18 196.5 107.37 195.82 106.99C195.14 106.61 194.53 107.51 194.82 109.58C195.11 111.65 194.56 120.19 194.56 120.19C194.56 120.19 193.01 122.26 190.68 125.11C188.35 127.96 169.68 144.78 162.68 150.22C155.68 155.66 154.92 160.06 153.88 165.49C152.84 170.92 151.81 202.49 151.81 213.9C151.81 225.31 152.81 243.4 153.62 249.36C154.43 255.32 153 263 152 267.18C151 271.36 152 274.94 154.85 277.01C157.7 279.08 169.85 280.38 179.95 280.38C190.05 280.38 200.4 279.38 203.51 278.31C206.62 277.24 209 277 209 272.87C209 268.74 206.93 260.45 206.93 258.12C206.93 255.79 211.08 231.72 211.08 231.72C211.08 231.72 237.48 239.72 242.4 237.93C247.32 236.14 288.47 197.29 288.47 197.29C288.47 197.29 294.94 194.7 298.31 194.18C301.68 193.66 306.85 191.34 307.11 190.56C307.37 189.78 306.59 190.04 304.52 190.04C302.675 190.166 300.849 190.501 299.08 191.04C299.08 191.04 306.15 186.56 307.37 186.12C308.21 185.81 309.66 183.9 307.63 184.31C305.08 184.82 298.83 186.64 298.83 186.64L307.11 181.46C307.11 181.46 308.4 179.39 306.85 179.39C305.3 179.39 297.53 184.05 297.53 184.05L303.53 178.43C304.7 177.35 303.72 175.82 302.34 176.62L295.34 180.62C293.633 181.618 291.822 182.426 289.94 183.03L288.65 183.81C288.907 182.442 289.081 181.059 289.17 179.67C289.17 178.37 288.39 175.01 286.58 174.75C284.77 174.49 286.32 177.08 286.32 178.37C286.32 179.66 283.73 186.37 283.73 187.43V190.54C283.73 190.54 274.93 198.3 266.91 202.45C258.89 206.6 240.76 220.31 240.76 220.31C240.76 220.31 220.06 209.69 215.4 205.81C210.74 201.93 205.56 197.27 200.4 193.13C197.721 190.902 194.865 188.895 191.86 187.13L175.05 186.42Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M261.55 205.65C252.76 211.27 240.79 220.33 240.79 220.33C240.79 220.33 220.09 209.71 215.43 205.83C210.77 201.95 205.59 197.29 200.43 193.15C197.751 190.922 194.895 188.915 191.89 187.15L175.07 186.38C175.07 186.38 173.51 183.01 173.51 180.94C173.51 178.87 172.51 169.03 172.51 169.03C172.51 169.03 180.26 155.03 186.16 145.18L185.69 144.7C182.79 141.81 178.78 140.25 175.28 139.4C170.4 143.73 165.55 147.9 162.67 150.14C155.67 155.57 154.91 159.98 153.87 165.41C152.83 170.84 151.8 202.41 151.8 213.82C151.8 225.23 152.8 243.32 153.61 249.28C154.42 255.24 153 263 152 267.18C151 271.36 152 274.94 154.85 277.01C157.7 279.08 169.85 280.38 179.95 280.38C190.05 280.38 200.4 279.38 203.51 278.31C206.62 277.24 209 277 209 272.87C209 268.74 206.93 260.45 206.93 258.12C206.93 255.79 211.08 231.72 211.08 231.72C211.08 231.72 237.48 239.72 242.4 237.93C245.02 236.93 258 225.43 269.51 214.93C267.415 211.398 264.722 208.258 261.55 205.65Z",
    fill: "#25BDBE",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M203 197.76C203 197.76 192.58 200.6 192 208.49",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M211 231.72C211 231.72 198.86 228.38 192.55 222.06",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M204.26 230C204.26 230 193.84 232.84 184.37 229.06",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M160.3 213.23C160.3 213.23 163.59 236.23 179.45 247.69",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M184.45 254C185.66 254.33 186.91 254.62 188.2 254.85",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M160.3 236.2C164.735 242.816 170.865 248.121 178.05 251.56",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M157.23 185.14C157.23 185.14 167.33 180.14 173.33 184.82",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M160.07 162.1C160.07 162.1 169.23 165.26 171.75 171.57",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M166.07 159.89C168.261 161.659 169.814 164.096 170.49 166.83",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M209.21 145C209.21 145 210.77 153.8 210.77 156.13C210.77 158.46 208.18 159.24 209.21 162.34C210.24 165.44 212.58 165.71 212.06 168.34C211.54 170.97 208.18 172.48 208.18 172.48C208.18 172.48 206.37 179.73 204.55 182.83C202.73 185.93 196.01 183.61 196.01 183.61L195.49 191.89C195.49 191.89 193.16 195.26 184.62 194.22C179.703 193.677 174.902 192.368 170.39 190.34L169.09 188.53C169.09 188.53 175.82 185.16 176.09 182.83C176.36 180.5 176.09 175.07 176.09 167.3C176.09 159.53 173.76 144.52 186.44 140.64C199.12 136.76 209.21 145 209.21 145Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M193.4 166.25C193.4 166.25 190.48 159.55 187.21 163.38C185.09 165.87 187.73 173.22 189.02 174.25C190.31 175.28 193.16 174.77 193.16 174.77C193.16 174.77 189.02 178.91 184.62 178.91C180.22 178.91 176.34 174.77 173.49 167.52C170.64 160.27 168.57 147.85 171.68 140.34C174.79 132.83 190.84 132.58 194.46 132.58C198.08 132.58 203.52 134.65 203.52 134.65C203.52 134.65 215.17 133.65 215.43 137.5C215.69 141.35 213.87 141.64 213.87 141.64C213.87 141.64 222.16 146.04 218.27 147.85C214.38 149.66 208.44 148.63 204.55 148.63C203.508 148.569 202.471 148.804 201.556 149.306C200.642 149.808 199.888 150.558 199.38 151.47C199.38 151.47 203 153.8 201.71 154.84C200.42 155.88 195.71 157.94 195.24 159.76C194.77 161.58 197.05 164.42 195.49 165.76C193.93 167.1 193.4 166.25 193.4 166.25Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M207.8 163.12C207.8 164.44 207.25 165.51 206.58 165.51C205.91 165.51 205.37 164.44 205.37 163.12C205.37 161.8 205.92 160.73 206.58 160.73C207.24 160.73 207.8 161.8 207.8 163.12Z",
    fill: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M203.56 160.07C203.56 160.07 205.23 156.17 207.88 158.26",
    stroke: "#263238",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M180.98 314.83L178.61 310.43L166.78 307.39",
    stroke: "white",
    strokeWidth: 1.03476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.775030adc3e7d4908bd7773067bf2b72.svg";
export { ForwardRef as ReactComponent };